import React from 'react';
import { DataTable } from 'primereact/datatable';
import moment from 'moment';
import { Column } from 'primereact/column';
import { StyledBoxTable } from '../../components/layout/main/mainStyles';
import { LoadingRowsComponent } from '../../components/commons/LoadingRows/LoadingRows';
import { UsersActivationTemplateProps } from './usersActivationTemplateProps';

export const UsersActivationTemplate = ({
  isLoading,
  isSuccess,
  allUsers,
  selectedItems,
  setSelectedItems
}: UsersActivationTemplateProps) => {
  const getFormattedDate = (rowData: { codeSentDate: string }) => {
    if (rowData.codeSentDate) {
      return moment
        .utc(rowData.codeSentDate)
        .local()
        .format('MM/DD/YYYY HH:mm');
    }
    return '';
  };

  const getStatus = () => {
    return 'Not Used';
  };

  return (
    <StyledBoxTable>
      {isLoading && <LoadingRowsComponent />}
      {isSuccess && allUsers && (
        <DataTable
          selectionMode="multiple"
          metaKeySelection
          selection={selectedItems}
          value={allUsers ?? []}
          size="small"
          scrollable
          scrollHeight="flex"
          onSelectionChange={(e) => setSelectedItems(e.value)}
          paginator={allUsers && allUsers.length >= 50}
          selectionPageOnly
          rows={50}
          rowsPerPageOptions={[5, 10, 20, 50]}
          tableStyle={{ padding: 0, margin: 0, fontSize: '14px' }}
          className="mt-3"
          rowHover
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: '3rem', visibility: 'hidden' }}
          />
          <Column field="email" header="Email" sortable />
          <Column field="email" header="Target" sortable />
          <Column field="key" header="Code" sortable />
          <Column header="Status" sortable body={getStatus} />
          <Column
            field="codeSentDate"
            header="Code Sent Date"
            sortable
            body={getFormattedDate}
          />
        </DataTable>
      )}
    </StyledBoxTable>
  );
};
